import moment from 'moment'

// dateUtils.ts
export const DAY_MS = 86400000
export const PRESETS = [2, 7, 14, 30, 90] as const
export const ymdcUtc = (d: moment.Moment) => d.utc().format('YYYY-MM-DD')
export const parseymdcUtc = (s: string) => moment.utc(s, 'YYYY-MM-DD', true)

export const pad2 = (n: number) => String(n).padStart(2, '0')
export const ymdLocal = (d: Date) => ymdcUtc(moment(d))

export const parseYMDLocal = (s: string) => {
  const [y, m, d] = (s || '').slice(0, 10).split('-').map(Number)
  return new Date(y, (m || 1) - 1, d || 1)
}

/** Trim any time portion: "YYYY-MM-DD HH:mm:ss" -> "YYYY-MM-DD" */
export const sanitizeYMD = (s?: string | null) => (s ? String(s).trim().slice(0, 10) : '')

/** Inclusive window ending today (local) */
export const subtractDaysWindowLocal = (n: number) => {
  const today = moment.utc().startOf('day')
  const from = moment.utc(today).subtract(n - 1, 'days')
  return { from: ymdcUtc(from), to: ymdcUtc(today) }
}

// Back-compat export name if some caller imports subtractDaysWindow
export { subtractDaysWindowLocal as subtractDaysWindow }
